(() => {
  const dayCampingReservationBreakdown = '.day-camping-reservation-breakdown'
  const planBlockRight = '.plan-block-right'
  const userInputRight = '.user-input-right'
  const eventReservationsInfoRight = '.event-reservations-info-right'
  const jsdayCampingReservationModal = '.js-day-camping-reservation-modal'

  const init = () => {
    $('body').on('click', dayCampingReservationBreakdown, rescissionFixedMenu)
      .on('hide.bs.modal', jsdayCampingReservationModal, setFixedMenu)
  }

  const rescissionFixedMenu = e => {
    $(planBlockRight).attr("style", "position: relative !important;");
    $(userInputRight).attr("style", "position: relative !important;");
    $(eventReservationsInfoRight).attr("style", "position: relative !important;");
  }

  const setFixedMenu = e => {
    if ( $(window).width() > 915 ) {
      $(planBlockRight).attr("style", "position: sticky;");
      $(userInputRight).attr("style", "position: sticky;");
      $(eventReservationsInfoRight).attr("style", "position: sticky;");
    } else {
      $(planBlockRight).attr("style", "position: relative;");
      $(userInputRight).attr("style", "position: relative;");
      $(eventReservationsInfoRight).attr("style", "position: relative;");
    }
  }
  $(init);
})();
